import { useTheme } from "@emotion/react";
import { Chip, Grid, useMediaQuery } from "@mui/material";
import React from "react";

const StoreOptionsGrid = ({ catering }) => {
  const theme = useTheme();
  const disableSticky = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Grid
      container
      justify="flex-end"
      direction="row"
      alignItems="center"
      justifyContent="center"
      className="sticky top-[190px] bg-[#e5e5e5]"
      style={disableSticky ? { position: 'initial', top: 'unset' } : {}}
    >
      {catering ?
        <Chip size="small" className="m-2" label="CT: Catering" />
        :
        <>
          <Chip size="small" className="m-2" label="WEB: www.ritasice.com" />
          <Chip size="small" className="m-2" label="DMB: Digital Menu Boards" />
          <Chip size="small" className="m-2" label="DT: Drive Thru" />
          <Chip size="small" className="m-2" label="OO: Online Ordering" />
        </>}
    </Grid>
  );
};

export default StoreOptionsGrid;
